import FareListContainerMobile from '../../../../components/containers/FareListContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadFareProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'fare-list--two-columns--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: FareListContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
